<template>
  <TableLayout :permissions="['business:workorder:query']">
    <!-- 搜索表单 -->
    <SearchFormCollapse slot="search-form">
      <el-form ref="searchForm" :model="searchForm" label-width="100px" inline>
        <el-form-item label="主键" prop="id">
          <el-input v-model="searchForm.id" placeholder="请输入主键" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="创建人编码" prop="creator">
          <el-input v-model="searchForm.creator" placeholder="请输入创建人编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="创建时间" prop="createDate">
          <el-date-picker v-model="searchForm.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间" @change="search"/>
        </el-form-item>
        <el-form-item label="更新人编码" prop="editor">
          <el-input v-model="searchForm.editor" placeholder="请输入更新人编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="更新时间" prop="editDate">
          <el-date-picker v-model="searchForm.editDate" value-format="yyyy-MM-dd" placeholder="请输入更新时间" @change="search"/>
        </el-form-item>
        <el-form-item label="是否删除0否 1是" prop="isdeleted">
          <el-input v-model="searchForm.isdeleted" placeholder="请输入是否删除0否 1是" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="所属分类编（关联category)" prop="categoryId">
          <el-input v-model="searchForm.categoryId" placeholder="请输入所属分类编（关联category)" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="searchForm.remark" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="状态 0待确认/待初审 1待分配/待终审 2待处理  3 已撤回 4已处理" prop="status">
          <el-input v-model="searchForm.status" placeholder="请输入状态 0待确认/待初审 1待分配/待终审 2待处理  3 已撤回 4已处理" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="排序码" prop="sortnum">
          <el-input v-model="searchForm.sortnum" placeholder="请输入排序码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="类型 0位置责任人 1班长 2物业主管 3工程师 4SHE负责人 5SHE工单邮箱抄送人" prop="type">
          <el-input v-model="searchForm.type" placeholder="请输入类型 0位置责任人 1班长 2物业主管 3工程师 4SHE负责人 5SHE工单邮箱抄送人" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="上报人员编码（关联member)" prop="memberId">
          <el-input v-model="searchForm.memberId" placeholder="请输入上报人员编码（关联member)" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="部门编码" prop="companyId">
          <el-input v-model="searchForm.companyId" placeholder="请输入部门编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="上报时间" prop="submitDate">
          <el-input v-model="searchForm.submitDate" placeholder="请输入上报时间" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="SHE涉及人员类型 0本人 1同事 2供应商" prop="memberType">
          <el-input v-model="searchForm.memberType" placeholder="请输入SHE涉及人员类型 0本人 1同事 2供应商" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="SHE涉及人员企业编码集合" prop="memberQwids">
          <el-input v-model="searchForm.memberQwids" placeholder="请输入SHE涉及人员企业编码集合" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="SHE涉及人员供应商集合" prop="memberNames">
          <el-input v-model="searchForm.memberNames" placeholder="请输入SHE涉及人员供应商集合" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="发生地点/位置编码（关联category）" prop="localtionId">
          <el-input v-model="searchForm.localtionId" placeholder="请输入发生地点/位置编码（关联category）" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="是否外部就医 0否 1是" prop="outJiuyi">
          <el-input v-model="searchForm.outJiuyi" placeholder="请输入是否外部就医 0否 1是" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="是否医务室 0否 1是" prop="isYiwushi">
          <el-input v-model="searchForm.isYiwushi" placeholder="请输入是否医务室 0否 1是" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="是否受伤 0否 1是" prop="isHurted">
          <el-input v-model="searchForm.isHurted" placeholder="请输入是否受伤 0否 1是" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="是否和工作相关" prop="workRelated">
          <el-input v-model="searchForm.workRelated" placeholder="请输入是否和工作相关" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="事件说明" prop="eventInfo">
          <el-input v-model="searchForm.eventInfo" placeholder="请输入事件说明" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="邮件通知人员编码集合" prop="emialMemberIds">
          <el-input v-model="searchForm.emialMemberIds" placeholder="请输入邮件通知人员编码集合" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="企业微信通知人员编码集合" prop="qwnoticeMemberIds">
          <el-input v-model="searchForm.qwnoticeMemberIds" placeholder="请输入企业微信通知人员编码集合" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="发现时间" prop="happenTime">
          <el-input v-model="searchForm.happenTime" placeholder="请输入发现时间" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="风险类型(关联category）" prop="typeId">
          <el-date-picker v-model="searchForm.typeId" value-format="yyyy-MM-dd" placeholder="请输入风险类型(关联category）" @change="search"/>
        </el-form-item>
        <el-form-item label="风险描述" prop="riskInfo">
          <el-input v-model="searchForm.riskInfo" placeholder="请输入风险描述" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="当前物业主管编码（关联member）" prop="managerId">
          <el-input v-model="searchForm.managerId" placeholder="请输入当前物业主管编码（关联member）" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="当前处理人员编码（关联member)" prop="dealerId">
          <el-input v-model="searchForm.dealerId" placeholder="请输入当前处理人员编码（关联member)" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="分配时间" prop="dispatchTime">
          <el-date-picker v-model="searchForm.dispatchTime" value-format="yyyy-MM-dd" placeholder="请输入分配时间" @change="search"/>
        </el-form-item>
        <el-form-item label="分配备注" prop="dispatchInfo">
          <el-input v-model="searchForm.dispatchInfo" placeholder="请输入分配备注" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="处理时间" prop="dealTime">
          <el-date-picker v-model="searchForm.dealTime" value-format="yyyy-MM-dd" placeholder="请输入处理时间" @change="search"/>
        </el-form-item>
        <el-form-item label="处理备注" prop="dealInfo">
          <el-input v-model="searchForm.dealInfo" placeholder="请输入处理备注" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="DCA问题编码" prop="problemId">
          <el-input v-model="searchForm.problemId" placeholder="请输入DCA问题编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="DCA问题数量" prop="problemNum">
          <el-input v-model="searchForm.problemNum" placeholder="请输入DCA问题数量" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="位置地点路径名称" prop="locationName">
          <el-input v-model="searchForm.locationName" placeholder="请输入位置地点路径名称" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="工单号" prop="code">
          <el-input v-model="searchForm.code" placeholder="请输入工单号" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <section>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </section>
      </el-form>
    </SearchFormCollapse>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:workorder:create', 'business:workorder:delete']">
        <li><el-button type="primary" @click="$refs.operaWorkorderWindow.open('新建工单信息表')" icon="el-icon-plus" v-permissions="['business:workorder:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:workorder:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="主键" min-width="100px"></el-table-column>
        <el-table-column prop="creator" label="创建人编码" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="editor" label="更新人编码" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="更新时间" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否删除0否 1是" min-width="100px"></el-table-column>
        <el-table-column prop="categoryId" label="所属分类编（关联category)" min-width="100px"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="status" label="状态 0待确认/待初审 1待分配/待终审 2待处理  3 已撤回 4已处理" min-width="100px"></el-table-column>
        <el-table-column prop="sortnum" label="排序码" min-width="100px"></el-table-column>
        <el-table-column prop="type" label="类型 0位置责任人 1班长 2物业主管 3工程师 4SHE负责人 5SHE工单邮箱抄送人" min-width="100px"></el-table-column>
        <el-table-column prop="memberId" label="上报人员编码（关联member)" min-width="100px"></el-table-column>
        <el-table-column prop="companyId" label="部门编码" min-width="100px"></el-table-column>
        <el-table-column prop="submitDate" label="上报时间" min-width="100px"></el-table-column>
        <el-table-column prop="memberType" label="SHE涉及人员类型 0本人 1同事 2供应商" min-width="100px"></el-table-column>
        <el-table-column prop="memberQwids" label="SHE涉及人员企业编码集合" min-width="100px"></el-table-column>
        <el-table-column prop="memberNames" label="SHE涉及人员供应商集合" min-width="100px"></el-table-column>
        <el-table-column prop="localtionId" label="发生地点/位置编码（关联category）" min-width="100px"></el-table-column>
        <el-table-column prop="outJiuyi" label="是否外部就医 0否 1是" min-width="100px"></el-table-column>
        <el-table-column prop="isYiwushi" label="是否医务室 0否 1是" min-width="100px"></el-table-column>
        <el-table-column prop="isHurted" label="是否受伤 0否 1是" min-width="100px"></el-table-column>
        <el-table-column prop="workRelated" label="是否和工作相关" min-width="100px"></el-table-column>
        <el-table-column prop="eventInfo" label="事件说明" min-width="100px"></el-table-column>
        <el-table-column prop="emialMemberIds" label="邮件通知人员编码集合" min-width="100px"></el-table-column>
        <el-table-column prop="qwnoticeMemberIds" label="企业微信通知人员编码集合" min-width="100px"></el-table-column>
        <el-table-column prop="happenTime" label="发现时间" min-width="100px"></el-table-column>
        <el-table-column prop="typeId" label="风险类型(关联category）" min-width="100px"></el-table-column>
        <el-table-column prop="riskInfo" label="风险描述" min-width="100px"></el-table-column>
        <el-table-column prop="managerId" label="当前物业主管编码（关联member）" min-width="100px"></el-table-column>
        <el-table-column prop="dealerId" label="当前处理人员编码（关联member)" min-width="100px"></el-table-column>
        <el-table-column prop="dispatchTime" label="分配时间" min-width="100px"></el-table-column>
        <el-table-column prop="dispatchInfo" label="分配备注" min-width="100px"></el-table-column>
        <el-table-column prop="dealTime" label="处理时间" min-width="100px"></el-table-column>
        <el-table-column prop="dealInfo" label="处理备注" min-width="100px"></el-table-column>
        <el-table-column prop="problemId" label="DCA问题编码" min-width="100px"></el-table-column>
        <el-table-column prop="problemNum" label="DCA问题数量" min-width="100px"></el-table-column>
        <el-table-column prop="locationName" label="位置地点路径名称" min-width="100px"></el-table-column>
        <el-table-column prop="code" label="工单号" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:workorder:update', 'business:workorder:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaWorkorderWindow.open('编辑工单信息表', row)" icon="el-icon-edit" v-permissions="['business:workorder:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:workorder:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaWorkorderWindow ref="operaWorkorderWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import SearchFormCollapse from '@/components/common/SearchFormCollapse'
import Pagination from '@/components/common/Pagination'
import OperaWorkorderWindow from '@/components/business/OperaWorkorderWindow'
export default {
  name: 'Workorder',
  extends: BaseTable,
  components: { SearchFormCollapse, TableLayout, Pagination, OperaWorkorderWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        categoryId: '',
        remark: '',
        status: '',
        sortnum: '',
        type: '',
        memberId: '',
        companyId: '',
        submitDate: '',
        memberType: '',
        memberQwids: '',
        memberNames: '',
        localtionId: '',
        outJiuyi: '',
        isYiwushi: '',
        isHurted: '',
        workRelated: '',
        eventInfo: '',
        emialMemberIds: '',
        qwnoticeMemberIds: '',
        happenTime: '',
        typeId: '',
        riskInfo: '',
        managerId: '',
        dealerId: '',
        dispatchTime: '',
        dispatchInfo: '',
        dealTime: '',
        dealInfo: '',
        problemId: '',
        problemNum: '',
        locationName: '',
        code: ''
      }
    }
  },
  created () {
    this.config({
      module: '工单信息表',
      api: '/business/workorder',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
